/**
 * Import Dependency
 */
import moment from 'moment'
import _ from 'lodash'
import localization from 'moment/locale/zh-hk'

function getState () {
  try {
    return JSON.parse(window.localStorage.getItem('state'))
  } catch (error) {
    return {}
  }
}

moment.updateLocale('zh-hk', {
  longDateFormat: {
    LT: 'Ahh:mm',
  },
})

/**
 * Config
 */
if (_.get(getState(), 'userLocale') === 'en') {
  moment.locale('en')
} else {
  moment.locale('zh-hk', localization)
}

/**
 * Export
 * Use RFC3339 Format: 2019-01-04T10:09:10.379Z
 */
export function isToday (data) {
  return moment(data).isSame(moment(), 'day')
}

export function getDateFormat (data) {
  const date = moment(data).local().format('YYYY-MM-DD')
  return date
}

export function getTimeFormat (data) {
  const time = moment(data).local().format('HH:mm:ss')
  return time
}

export function getTimeslotFormat (data, locale, skipImeediate) {
  if (!skipImeediate && moment(data).local().diff(moment(new Date()), 'minutes') <= 1) {
    if (locale === 'zh') {
      return '即時'
    } else {
      return 'Immediate'
    }
  }

  if (locale === 'zh') {
    const time = moment(data).local().format('MM月DD日 HH:mm')
    return time
  }

  const time = moment(data).local().format('MM/DD HH:mm')
  return time
}

export function getMonthOptionArr () {
  return [
    { name: 'JAN', val: '1' },
    { name: 'FEB', val: '2' },
    { name: 'MAR', val: '3' },
    { name: 'APR', val: '4' },
    { name: 'MAY', val: '5' },
    { name: 'JUN', val: '6' },
    { name: 'JUL', val: '7' },
    { name: 'AUG', val: '8' },
    { name: 'SEP', val: '9' },
    { name: 'OCT', val: '10' },
    { name: 'NOV', val: '11' },
    { name: 'DEB', val: '12' },
  ]
}

export function getYearOptionArr () {
  var tmp = []
  for (var i = 0; i < 10; i++) {
    const yr = moment(Date()).year() + i
    tmp.push({ name: yr, val: yr })
  }
  return tmp
}

const findMinDeliveryStart = (currentTime, minDeliveryHour) => {
  const min = moment(currentTime).add(minDeliveryHour, 'hours')
  const durationOneStart = moment(min.format('YYYY-MM-DD')).add(10, 'hours') // > min 早於 minTimeSlotStart --> 當天 10:00 ~ 13:00
  const durationTwoStart = moment(min.format('YYYY-MM-DD')).add(14, 'hours') // > min 晚於 minTimeSlotStart --> 明天 10:00 ~ 13:00
  // const durationOneEnd = moment(min.format('YYYY-MM-DD')).add(13, 'hours')
  // const durationTwoEnd = moment(min.format('YYYY-MM-DD')).add(18, 'hours')

  if (min.isSameOrBefore(durationOneStart)) {
    return durationOneStart
  } else if (min.isAfter(durationTwoStart)) {
    return durationOneStart.add(1, 'days')
  } else if (min.isBetween(durationOneStart, durationTwoStart, '(]')) { // > 13:01 ~ 14:00 --> 當天 14:00 ~ 18:00
    return durationTwoStart
  }
}

const findMaxDeliveryStart = (currentTime, maxDeliveryHour) => {
  const max = moment(currentTime).add(maxDeliveryHour, 'hours')
  const durationOneStart = moment(max.format('YYYY-MM-DD')).add(10, 'hours') // > max 早於 maxTimeSlotStart --> 昨天 14:00 ~ 18:00
  const durationOneEnd = moment(max.format('YYYY-MM-DD')).add(13, 'hours')
  const durationTwoStart = moment(max.format('YYYY-MM-DD')).add(14, 'hours')
  const durationTwoEnd = moment(max.format('YYYY-MM-DD')).add(18, 'hours') // > max 晚於 maxTimeSlotEnd --> 當天 14:00 ~ 18:00

  if (max.isBefore(durationOneStart)) {
    return durationOneStart.add(-1, 'days').add(4, 'hours') // >  昨天 14:00
  } else if (max.isAfter(durationTwoEnd)) {
    return durationOneStart.add(4, 'hours') // > 當天 14:00
  } else if (max.isBetween(durationOneEnd, durationTwoStart, '()')) { // > 13:01 ~ 13:59 --> 當天 10:00 ~ 13:00
    return durationOneStart
  } else if (max.isBetween(durationOneStart, durationOneEnd, '[]')) {
    return durationOneStart
  } else if (max.isBetween(durationTwoStart, durationTwoEnd, '[]')) {
    return durationTwoStart
  }
}

export function getShopDeliveryTimeSlot (currentTime, minDeliveryHour, maxDeliveryHour) {
  if (!currentTime) {
    return {
      minDeliveryStart: moment(),
      maxDeliveryStart: moment(),
    }
  }

  const minDeliveryStart = findMinDeliveryStart(currentTime, minDeliveryHour)
  const maxDeliveryStart = findMaxDeliveryStart(currentTime, maxDeliveryHour)

  return {
    minDeliveryStart,
    maxDeliveryStart,
  }
}

export function round (date, duration, method) {
  return moment(Math[method]((+date) / (+duration)) * (+duration))
}



// WEBPACK FOOTER //
// ./src/helpers/date.js